import React, { Component } from 'react'
import Axios from 'axios';
import qs from 'qs';
import { Input, Modal, Select, Form, DatePicker, notification, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import $ from 'jquery';
import { Link } from "react-router-dom";
import AsideLeft from '../../components/aside/asideleft';
import {
    PATIENT_DATA,
    Get_Obs_Gyane_Data,
    Save_Obs_Gyane_Data,
    VaccinationList,
    VaccinationItemList,
    VaccinationAdd,
    VaccinationRecordList,
    VACCINATION_SITES,
    PAEDRATICVACCINEID,
    RISK_FACTORS_LIST,
    OBJECTIVE_GETALL,
    DURATION_TYPE,
    INFORMED_BY,
    MEDICATION_ON,
    FETAL_MOVEMENT,
    PRESENTATION,
    RELATIONSHIP_TO_PP_BRIM,
    LOADER,
    CONCEPTION_OPTIONS,
    PREGNANCY_OPTIONS,
    DELIVERY_OPTIONS,
    OUTCOME_OPTIONS,
    PLACE_OF_DELIVERY_OPTIONS,
    ISALLOWEDITSOAP,
    Save_Anc_Details,
    Get_Anc_Details,
    Get_Anc_Previous_Details,
    Get_Previous_Mother_Fetus_History,
    Print_Anc_Details,

} from "../../utils/constant";
import { speechService, speechTextService, pregnantService } from '../../utils/rxjs-sharing';
import MyHcSpeechRecognition from "../../pages/speech-to-text/speech-recognition";
import LS_SERVICE from "../../utils/localStorage";
import { headerService$ } from '../../utils/rxjs-sharing';
import moment from "moment";
import MultiplePregnancies from './sscomponents/MultiplePregnancies';
import DeliveryDetailsModal from './sscomponents/DeliveryDetailsModal';
import MotherParameterModal from './sscomponents/MotherParameterModal';
import FetusModal from './sscomponents/FetusModal';
import PreviousMotherHistoryModal from './sscomponents/PreviousMotherHistoryModal';
import VaccineOptional from './sscomponents/VaccineOptional';
import AncTestProcedures from './sscomponents/AncTestProcedures';
import AncCardView from '../patient-detail/anccardview';
const { Option } = Select;

export default class AncCard extends Component {
    constructor(props) {
        super(props);
        this.ancFormRef = React.createRef();
        this.state = {
        	patientInfo: null,
        	patient_id: null,
        	reference_id: null,
        	anc_id: null,
        	reference_type: null,
        	doctor_id: null,
        	current_allergies : [],
        	current_conditions : [],
        	risk_factors_options: [],
        	pregnancy_risk_factor : [],
      		pregnancy_risk_factor_selected: [],
      		pregnancy_risk_factor_management_remarks : null,
        	vaccineData : [],
        	vaccineItemList : [],
        	vaccinationSites : VACCINATION_SITES,
        	currentPregnancyData : null,
        	speech: {
                identifier: null,
                state: false
            },
            immuno_remarks : null,
            investigation_remarks : null,
            test_procedures_data : [{ title: '', description: '' }],
            conception_options: CONCEPTION_OPTIONS,
            pregnancy_options: PREGNANCY_OPTIONS,
            delivery_options: DELIVERY_OPTIONS,
            outcome_options: OUTCOME_OPTIONS,
            place_of_delivery_options: PLACE_OF_DELIVERY_OPTIONS,
            pregnancy_year : null,
            year_options: [],
            delivery_mode : null,
            pregnancy_type : null,
            delivery_type : null,
            delivery_place : null,
            delivery_outcome : null,
            delivery_bith_date_time : null,
            delivery_gender : null,
            delivery_birth_weight : null,
            delivery_birth_height : null,
            delivery_birth_head_cc : null,
            delivery_congenital_abnormality : false,
            delivery_congenital_abnormality_remarks : null,
            delivery_indication_for_c_section : null,
            delivery_details : null,
            multiple_pregnancies : [],
            allowEdit:false,
            multiplePregnanciesModal: false,
            deliveryDetailsModalVisible: false,
            motherParameterModalVisible: false,
            fetusModalVisible: false,
            previousMotherParameterModalVisible: false,
            previousMotherFetusModalVisible: false,
            previousMotherParameters: [],
            previousMotherFetusData: [],
            prevAncCardData : [],
            showRxModal: false,
    		rxPdfPath: null,
    		isPrintLoader: false,
    		spin_loading : false,
    		// Patient-level pregnancy flag (drives the Pregnancy Active / Close Pregnancy header).
    		// Initialised from LS and kept live via pregnantService.
    		isPatientPregnant: LS_SERVICE.get('PATIENT_PREGNANT_STATUS') == "1",
        }
    }

    componentDidMount = async () => {
    	const { match: { params } } = this.props;
    	await this.setState({
    		patient_id: params.patient_id,
            reference_id: params.reference_id,
            reference_type: params.reference_type,
            doctor_id: (LS_SERVICE.get('user_type') === 2) ? LS_SERVICE.get('selectedDoctorIdAppoinement') : LS_SERVICE.get('staff_id')
    	});
    	let hospitalConfigData = LS_SERVICE.get('hospitalConfigData')??[];
        hospitalConfigData = hospitalConfigData.find(item=>item.hospital_id==params.hospital_id);

        let allowEdit = hospitalConfigData?ISALLOWEDITSOAP(hospitalConfigData.pres_modification, hospitalConfigData.allow_hours, LS_SERVICE.get('appointmentCompletedTime')[params.reference_id], 'button', LS_SERVICE.get('TIMEZONE_OFFSET_MINUTES')):true;

        this.setState({
            allowEdit,
        }, async () => {
            if (LS_SERVICE.has('hospitalConfigData')) {
                const hospitalConfigData = LS_SERVICE.get('hospitalConfigData');
                let hospitalConfigObj = hospitalConfigData.find(obj => obj.hospital_id == params.hospital_id);
                headerService$.soapConfig({ soapConfig: hospitalConfigObj.opd_layout }); // IMPORTANT TO HIT AS PER THE VIEW
            }
        });
    	let cyear = new Date().getFullYear();
        let syear = cyear - 20;
        let year_options = [];

        for (let i = cyear; i >= syear; i--) {
            year_options.push(i);
        }
        this.setState({
            year_options
        });
    	const ss_configuration = LS_SERVICE.get('ss_configuration');
	    const patient_full_data = LS_SERVICE.get('call_patient_detail');
	    await this.setState({
	        ss_configuration: ss_configuration,
	        consult_type: patient_full_data?.consult_type == 1 ? 'vc' : 'opd'
	    })
    	// Keep the patient pregnancy flag live (e.g. cleared after closing the pregnancy).
    	this.pregnantSubscription = pregnantService.status().subscribe(data => {
            if (data && typeof data.is_pregnant !== 'undefined') {
                this.setState({ isPatientPregnant: data.is_pregnant == "1" });
            }
        });
    	this.subscription = speechTextService.status().subscribe((data) => {
            if (this.state.speech.state) {
                if (this.state.speech.identifier === "pregnancy_risk_factor_management_remarks") {
                    this.ancFormRef?.current?.setFieldsValue({ pregnancy_risk_factor_management_remarks: data.text });

                    document.querySelector(
                        "#" + this.state.speech.identifier
                    ).style.height =
                        document.querySelector("#" + this.state.speech.identifier)
                            .scrollHeight + "px";
                }
                if (this.state.speech.identifier === "delivery_details") {
                    this.ancFormRef?.current?.setFieldsValue({ delivery_details: data.text });

                    document.querySelector(
                        "#" + this.state.speech.identifier
                    ).style.height =
                        document.querySelector("#" + this.state.speech.identifier)
                            .scrollHeight + "px";
                }

                if (this.state.speech.identifier === "delivery_indication_for_c_section") {
                    this.ancFormRef?.current?.setFieldsValue({ delivery_indication_for_c_section: data.text });

                    document.querySelector(
                        "#" + this.state.speech.identifier
                    ).style.height =
                        document.querySelector("#" + this.state.speech.identifier)
                            .scrollHeight + "px";
                }

                if (this.state.speech.identifier === "immuno_remarks") {
                    this.ancFormRef?.current?.setFieldsValue({ immuno_remarks: data.text });

                    document.querySelector(
                        "#" + this.state.speech.identifier
                    ).style.height =
                        document.querySelector("#" + this.state.speech.identifier)
                            .scrollHeight + "px";
                }

                if (this.state.speech.identifier === "delivery_congenital_abnormality_remarks") {
                    this.ancFormRef?.current?.setFieldsValue({ delivery_congenital_abnormality_remarks: data.text });

                    document.querySelector(
                        "#" + this.state.speech.identifier
                    ).style.height =
                        document.querySelector("#" + this.state.speech.identifier)
                            .scrollHeight + "px";
                }

            }
        });
        this.getVaccineItemList(params.hospital_id);
        // Load the core patient + current-pregnancy data first. These drive the header and the
        // Menstrual/Obstetric sections (via currentPregnancyData) and must be set before render,
        // so they run sequentially rather than racing each other's setState calls.
        await this.getPatientData();
        await this.getPatientObsGyaneData();
        // The rest are independent of each other, so run them together to cut the load time.
        await Promise.all([
            this.optionRiskFactorsList(),
            // Pre-fetch patient-level previous mother/fetus history so the "Previous ..." links
            // can be shown only when there is data available.
            this.getPreviousMotherHistory(),
            this.handleObjectiveGetAllData(),
        ]);
        // Loads the active ANC card and sets this.state.anc_id (needed by the calls below).
        await this.getPatientAncDetails();
        // These both depend on the active card being loaded (anc_id / vaccine config), but are
        // independent of each other - run them in parallel so Previous ANC cards no longer wait
        // behind the vaccination-record merge.
        await Promise.all([
            // Merge previously saved vaccines (shared vaccination records) into the vaccine rows.
            this.getSavedVaccinationRecords(),
            this.getPatientAncPreviousDetails(),
        ]);
    }

    printAncDetails = async () => {
        // Save the ANC data first so the print always reflects the latest edits. If the save
        // was aborted (e.g. vaccine validation failed), onFinishAncForm returns false — do NOT
        // proceed to print stale/unsaved data; the validation error is already shown.
        const saved = await this.onFinishAncForm("print");
        if (saved === false) {
            return;
        }
        // Re-fetch the ANC card so anc_id (and all saved sections) are current before printing.
        // On a first-ever save the card is created server-side but its id isn't returned by the
        // save response, so this refresh is what gives us a valid anc_id to print.
        await this.getPatientAncDetails();
        // getPatientAncDetails() rebuilds the vaccine checklist from config (getVaccineData),
        // which clears the given/saved vaccine values on screen. Re-merge the saved vaccination
        // records afterward (same order as componentDidMount) so the vaccine rows keep showing
        // their data without needing a manual page refresh.
        await this.getSavedVaccinationRecords();
	    const BODY = {
	    	patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
			hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
			enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
			anc_id: parseInt(this.state.anc_id),
            printed_by : parseInt(LS_SERVICE.get('staff_id')),
	    }
	    await this.setState({ isPrintLoader : true });
	    await Axios.post(Print_Anc_Details, BODY).then(async (response) => {
			if(response.data.status == true)
			{
				await this.setState({ rxPdfPath: response.data.pdf_url, showRxModal: true, });

			} else {
				notification.error({
	                message: "Oops! Something snapped. Please try again.",
	                placement: "topRight",
	            });
			}
	    	await this.setState({ isPrintLoader : false });
	    }).catch(async (err) => {
			notification.error({
                message: "Oops! Something snapped. Please try again.",
                placement: "topRight",
            });
            await this.setState({ isPrintLoader : false });
	    });
    
  	}

    onFinishAncForm = async (submit_type = null) => {
        // Validate vaccine rows (same rules as the Vaccination Record page) before saving.
        const vaccineValidation = this.validateVaccineData();
        if (!vaccineValidation.valid) {
            notification.error({
                message: vaccineValidation.message,
                placement: 'topRight'
            });
            return false;
        }
        if(submit_type != "print")
        {
          await this.setState({ spin_loading : true });
        }
    	// Refresh the obs/gynae data so the snapshot below captures EVERY mother-parameter
    	// reading recorded this session (multiple readings are allowed), not a stale copy.
    	await this.getPatientObsGyaneData();
    	// Only the vaccines actually administered (given on a date, or given outside) are
    	// snapshotted onto the ANC card, so the Previous Card shows a clean, meaningful list.
    	const administeredVaccines = this.getAdministeredVaccines();
    	let anc_details = {
			patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
			reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
			reference_type: 0,
			hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
			enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
			source: 'OP',
			current_allergies : this.state.current_allergies ? JSON.stringify(this.state.current_allergies) : null,
			current_conditions : this.state.current_conditions ? JSON.stringify(this.state.current_conditions) : null,
			vaccine_data : administeredVaccines.length > 0 ? JSON.stringify(administeredVaccines) : null,
			// Snapshot of the current pregnancy (obs & gynae) data at save time, persisted
			// as JSON in the anc table's obs_gyane_data column. A reference id can have
			// MULTIPLE mother-parameter readings, so persist the full history
			// (mother_parameter_data_all) alongside the latest (mother_parameter_data) so the
			// closed card / print shows every reading, not just the most recent one.
			obs_gyane_data : this.state.currentPregnancyData ? JSON.stringify(this.buildObsGyaneSnapshot()) : null,
			// Investigations remarks -> patient_obs_gyane_anc_cards.investigation_remarks.
			investigation_remarks : this.state.investigation_remarks || null,
			// Title/Description rows for the Investigations section. Stored in
			// patient_obs_gyane_anc_test_procedure_data (keyed by anc_card_id). Only rows with
			// real text are sent; title/description hold rich-text HTML (e.g. <b>bold</b>), so
			// emptiness is checked against the stripped plain text.
			test_procedures_data : (this.state.test_procedures_data || [])
				.filter(row => this.hasRichTextContent(row.title) || this.hasRichTextContent(row.description))
				.map(row => ({
					title : this.hasRichTextContent(row.title) ? row.title : null,
					description : this.hasRichTextContent(row.description) ? row.description : null,
					created_by : LS_SERVICE.get('profile')?.data?.full_name || ("Dr. " + LS_SERVICE.get('staff_name')),
				})),
			immuno_remarks : this.state.immuno_remarks,
			pregnancy_year : this.state.pregnancy_year || null,
			delivery_mode : this.state.delivery_mode || null,
			pregnancy_type : this.state.pregnancy_type || null,
			delivery_indication_for_c_section : this.state.delivery_indication_for_c_section || null,
			delivery_details : this.state.delivery_details || null,
			// Gestational age today (label like "38w 2d"), derived from LMP / corrected-or-EDD,
			// so it is persisted on the ANC card and shown on the Previous Card view.
			delivery_gestational_age : this.getGAToday(
				this.state.currentPregnancyData?.menstural_data?.lmp,
				this.state.currentPregnancyData?.corrected_edd || this.state.currentPregnancyData?.edd_by_lmp
			) || null,
			created_by : LS_SERVICE.get('staff_id'),
			updated_by : LS_SERVICE.get('staff_id'),
            is_closed : '0',
	    }
	    if(this.state.pregnancy_type != "2")
	    {
	    	anc_details.delivery_type = this.state.delivery_type || null;
			anc_details.delivery_place = this.state.delivery_place || null;
			anc_details.delivery_outcome = this.state.delivery_outcome || null;
			anc_details.delivery_gender = this.state.delivery_gender || null;
			anc_details.delivery_bith_date_time = this.state.delivery_bith_date_time != null ? moment(this.state.delivery_bith_date_time).format('YYYY-MM-DD HH:mm:ss') : null;
			anc_details.delivery_birth_weight = this.state.delivery_birth_weight || null;
			anc_details.delivery_birth_height = this.state.delivery_birth_height || null;
			anc_details.delivery_birth_head_cc = this.state.delivery_birth_head_cc || null;
			anc_details.delivery_congenital_abnormality = this.state.delivery_congenital_abnormality ? 'true' : 'false';
			anc_details.delivery_congenital_abnormality_remarks = this.state.delivery_congenital_abnormality_remarks || null;
	    }
	    else
	    {
	    	anc_details.multiple_pregnancies = this.state.multiple_pregnancies;
	    }
	    let where_condition = {
			patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
			reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
			reference_type: 0,
			hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
			enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
			source: 'OP',
	    }

	    let Params = {
			where_condition,
			anc_details,
	    };
	    // console.log(this.state.vaccineData);
	    // console.log(Params);

	    // return false;
	    // Tracks whether the save succeeded so callers (e.g. Print) can avoid printing stale data.
	    let saveSucceeded = true;
	    await Axios.post(Save_Anc_Details,Params).then(async res => {
            // Persist vaccines to the shared vaccination records (same as Vaccination Record page).
            await this.saveVaccinationData();
            // Re-fetch the shared vaccination records so the just-saved rows pick up their new
            // id (and given-on/site/batch). Rows with id > 0 are locked in render, so this makes
            // an administered vaccine become non-editable immediately without a page reload.
            await this.getSavedVaccinationRecords();
	    	if(submit_type != "print")
            {
                notification.success({
                  message: "Anc card saved successfully",
                  placement: "topRight",
                });
                await this.setState({ spin_loading : false });
            }
            await this.handleSaveObsGyaneData();
	    })
	    .catch(async (error) => {
			notification.error({
				message: 'Something went wrong! Unable to save the data',
				placement: 'topRight'
			})
    		await this.setState({ spin_loading : false });
    		saveSucceeded = false;
	    });
	    // Signal success/failure so Print can decide whether to fetch + print.
	    return saveSucceeded;
    }

    handleSaveObsGyaneData = async () => {
	    let obs_gyane_data = {
	      pregnancy_risk_factor : this.state.pregnancy_risk_factor.length > 0 ? this.state.pregnancy_risk_factor.toString(): null,
	      pregnancy_risk_factor_management_remarks : this.state.pregnancy_risk_factor_management_remarks,
	      updated_by : LS_SERVICE.get('staff_id')
	    }
	    let where_condition = {
	      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
	      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
	      reference_type: 0,
	      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
	      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
	      source: 'OP',
	    }

	    let Params = {
	      where_condition,
	      obs_gyane_data,
	    }
	    await Axios.post(Save_Obs_Gyane_Data,Params).then(async res => {
	    })
	    .catch(error => {
	      notification.error({
	        message: 'Something went wrong! Unable to save the data',
	        placement: 'topRight'
	      })
	    })
  	}

    disabledPastDate(current) {
        return current && (current > moment());
    }

    handleObjectiveGetAllData = async () => {
        const { patient_id } = this.state;
        const objectiveGetAllPromise = await Axios.get(OBJECTIVE_GETALL({ patient_id }));

        if (objectiveGetAllPromise.data.status) {
            const { data } = objectiveGetAllPromise.data;
            const { details, constants } = data;
            const { allergies, conditions } = details;
            await this.setState({
                current_allergies : allergies.patientAllergies,
                current_conditions : conditions.patientConditions,
            });
        }
    };

    optionRiskFactorsList() {
        Axios.get(RISK_FACTORS_LIST).then(async success => {
            if (success?.data?.status == true) {
                this.setState({ risk_factors_options: success.data.data });
            }
        }).catch(err => console.log(err));
    }

    optionRiskFactorsLoad() {
        if (!this.state.risk_factors_options || this.state.risk_factors_options.length === 0) {
            return (<Option value={0}><span>No Result Found</span></Option>)
        }
        return this.state.risk_factors_options.map((obj, i) => {
            return (<Option key={i} value={parseInt(obj.id)} title={obj.description}>{obj.description}</Option>)
        }, this)
    }

    // Loads the vaccine name (item) master list for the Vaccine Name dropdown.
    // Uses the ANC route's hospital id (falls back to slot_hospital_id / FACILITY_ID).
    getVaccineItemList = (routeHospitalId) => {
        const hospital_id = routeHospitalId || LS_SERVICE.get('slot_hospital_id') || LS_SERVICE.get('FACILITY_ID');
        Axios.post(VaccinationItemList, qs.stringify({ drug_class: PAEDRATICVACCINEID, hospital_id: hospital_id }))
            .then((response) => {
                // Response may be an object like { status, data: [...] } or a plain array.
                // Find the first array in the response values (robust to key/order differences).
                let list = [];
                const data = response?.data;
                if (Array.isArray(data)) {
                    list = data;
                } else if (data && typeof data === 'object') {
                    const values = Object.values(data);
                    const foundArray = values.find(v => Array.isArray(v));
                    list = foundArray || [];
                }
                this.setState({ vaccineItemList: list });
            })
            .catch(err => console.log(err));
    }

    getVaccineData() {
        let totalvaccine_data = []
        let params = { anc: 'active' };
        return Axios.post(VaccinationList, params)
        .then((success) => {
            let totalvaccine = success.data.data;
            let alredyAddedVaccine = [];
            totalvaccine?.map(ele => {
                if (ele.anc == "Y" && !alredyAddedVaccine.includes(ele.vaccinationId)) {
                    let i;
                    for (i = 1; i <= ele.noOfDoses; i++) {
                        totalvaccine_data.push({
                            active: ele.active,
                            anc: ele.anc,
                            name: ele.name + " " + i,
                            noOfDoses: ele.noOfDoses,
                            type: ele.type,
                            vaccinationId: ele.vaccinationId,
                            vaccine_list: ele.vaccine_list,
                            dose_number: i,
                            scheduleDoseNo: i,
                            emr_vaccination_id: ele.id,
                            dose_id: ele.id,
                            // Age window fields (from the vaccine config) used to compute the
                            // Due Now / Missed status, same as the Vaccination Record page.
                            startAge: ele.startAge,
                            startAgeDuration: ele.startAgeDuration,
                            endAge: ele.endAge,
                            endAgeDuration: ele.endAgeDuration,
                            id: 0,
                            reference_id: 0,
                            vaccine_status : "false",
                            vaccine_date : null,
                            given_outside : 0,
                            vac_site : '',
                            item : '',
                            batch : '',
                            expiry_date : null,
                            remark : ''
                        });
                    }
                    alredyAddedVaccine.push(ele.vaccinationId)
                }                
            });
            this.setState({ vaccineData: totalvaccine_data });
        });
    }

    handleModalPopup = async (e, popup) => {
        if (e !== null) e.preventDefault();
        this.setState({
            [popup]: !this.state[popup],
        });
    }

    handleModalSave = async (obj) => {
        if (obj?.multiple_pregnancies != undefined) {
            await this.setState({
                multiple_pregnancies: obj.multiple_pregnancies
            });
        }
        else
        {
        	await this.setState({
                multiple_pregnancies: []
            });
        }
        await this.setState({
            multiplePregnanciesModal: false,
        });

        // console.log(this.state.multiple_pregnancies)
    }

    getPatientData = async () => {
        const { patient_id } = this.state;
        // Return the promise so callers can await patientInfo being set (its patient_id is
        // the canonical id shared with the Vaccination Record page).
        return Axios.get(PATIENT_DATA({ patient_id }))
        .then(async (success) => {
            const patientInfo = {
                ...success.data.data.results,
                qms_token_id: success.data.data.results.qmsToken
                    ? success.data.data.results.qmsToken.qms_token_id
                    : null,
            };
            const isPregnant = patientInfo?.is_pregnant == "1";
            await this.setState({
                patientInfo,
                // Seed the patient-level pregnancy flag from the patient record.
                isPatientPregnant: isPregnant,
            });
            // Persist and broadcast the pregnancy flag so the left sidebar header badge
            // (Pregnant icon) reflects the correct status on first ANC open, without a reload.
            // AsideLeft sources is_pregnant from its own fetch + this live pregnantService stream.
            LS_SERVICE.set('PATIENT_PREGNANT_STATUS', isPregnant ? "1" : "0");
            pregnantService.init({ is_pregnant: isPregnant ? "1" : "0" });
        })
        .catch((err) => console.log(err));
    }

    componentWillUnmount() {
        this?.subscription?.unsubscribe();
        this?.pregnantSubscription?.unsubscribe();
    }

    //Speech
    initSpeech(info) {
        let initialText = '';
        if (info.identifier === 'pregnancy_risk_factor_management_remarks') {
            initialText = this.state.pregnancy_risk_factor_management_remarks != undefined ? this.state.pregnancy_risk_factor_management_remarks : '';
        }
        if (info.identifier === 'delivery_details') {
            initialText = this.state.delivery_details != undefined ? this.state.delivery_details : '';
        }
        if (info.identifier === 'delivery_indication_for_c_section') {
            initialText = this.state.delivery_indication_for_c_section != undefined ? this.state.delivery_indication_for_c_section : '';
        }

        if (info.identifier === 'delivery_congenital_abnormality_remarks') {
            initialText = this.state.delivery_congenital_abnormality_remarks != undefined ? this.state.delivery_congenital_abnormality_remarks : '';
        }

        if (info.identifier === 'immuno_remarks') {
            initialText = this.state.immuno_remarks != undefined ? this.state.immuno_remarks : '';
        }

        if (info.identifier === this.state.speech.identifier) {
            this.setState({
                speech: {
                    identifier: info.identifier,
                    state: !this.state.speech.state,
                    initialText: initialText
                }
            }, () => {
                speechService.init(this.state.speech);
            });
        }
        else {
            this.setState({
                speech: {
                    identifier: this.state.speech.identifier,
                    state: false,
                    initialText: ''
                }
            }, () => {
                speechService.init(this.state.speech);
                setTimeout(() => {
                    this.setState({
                        speech: {
                            identifier: info.identifier,
                            state: true,
                            initialText: initialText
                        }
                    }, () => {
                        speechService.init(this.state.speech);
                    });

                }, 1000);
            });
        }
    }

    // Gestational Age "today" on the basis of LMP & EDD.
    // Preferred: days elapsed since LMP. Fallback (no LMP): derive from EDD, since a
    // term pregnancy is 280 days (40w) from LMP and EDD = LMP + 280 days, so
    // GA today = 280 - days remaining until EDD.
    // Returns a short label like "71w 1d" (empty string when neither is available).
    getGAToday = (lmp, edd) => {
        let totalDays = null;
        if (lmp) {
            const lmpMoment = moment(lmp);
            if (lmpMoment.isValid()) {
                totalDays = moment().startOf('day').diff(lmpMoment.startOf('day'), 'days');
            }
        }
        if ((totalDays === null || isNaN(totalDays)) && edd) {
            const eddMoment = moment(edd);
            if (eddMoment.isValid()) {
                const daysToEdd = eddMoment.startOf('day').diff(moment().startOf('day'), 'days');
                totalDays = 280 - daysToEdd;
            }
        }
        if (totalDays === null || isNaN(totalDays) || totalDays < 0) return '';
        const weeks = Math.floor(totalDays / 7);
        const days = totalDays % 7;
        return weeks + 'w ' + days + 'd';
    }

    handleOnPregnancyRiskFactorChange = async (val,props) => {
	    let pregnancy_risk_factor_selected_data = [];
	    await this.setState({
	      pregnancy_risk_factor_selected: val,
	      obs_gyane_change_detected : true
	    });
	    props.forEach(element => {
	      pregnancy_risk_factor_selected_data.push(element.value);
	    });

	    await this.setState({
	      pregnancy_risk_factor: pregnancy_risk_factor_selected_data.join(),
	      obs_gyane_change_detected: true
	    });
	}

    autoHeight = (e) => {
	    if (e)
	    {
	    	e.target.style.height = e.target.scrollHeight + "px";
	    }	
    }  

    handleOnTextChange = async(event) => {
	    const { name, value } = event.currentTarget;
	    await this.setState({
	      [name]: value
	    });
	    await this.ancFormRef.current.setFieldsValue({
	      [name]: value
	    });
  	}

    // True when the rich-text HTML has actual visible text once tags/entities are stripped.
    // Used to skip empty Title/Description rows (markup like "<br>"/"&nbsp;") from the save payload.
    hasRichTextContent = (html) => {
        if (!html) return false;
        const text = String(html)
            .replace(/<[^>]*>/g, '')
            .replace(/&nbsp;/g, ' ')
            .trim();
        return text !== '';
    }

    handleVaccineDate = async (date, dateString, index, field) => {
	    await this.setState(prevState => {
	      const prevItems = [...prevState.vaccineData];
	      prevItems[index][field] = moment(date).format("YYYY-MM-DD");
	      prevItems[index]['vaccine_status'] = "true";
	      return { vaccineData: prevItems };
	    });

	    // console.log(this.state.vaccineData);
  	}

    // Generic text/select field update for a vaccine row (batch, remark, etc.)
    handleVaccineFieldChange = async (event, index, field) => {
	    const value = event?.target?.value;
	    await this.setState(prevState => {
	      const prevItems = [...prevState.vaccineData];
	      prevItems[index][field] = value;
	      return { vaccineData: prevItems };
	    });
    }

    // Select (antd) update for a vaccine row (vaccine name/item, vaccination site).
    handleVaccineSelectChange = async (value, index, field) => {
	    await this.setState(prevState => {
	      const prevItems = [...prevState.vaccineData];
	      prevItems[index][field] = value;
	      return { vaccineData: prevItems };
	    });
    }

    // ACTION "+" : add another editable dose row for the same vaccine (id 0 => new record).
    // Inserted right after the clicked row, cloning the vaccine identity with blank data.
    handleVaccineAddDose = async (index) => {
	    await this.setState(prevState => {
	      const prevItems = [...prevState.vaccineData];
	      const src = prevItems[index];
	      if (!src) return { vaccineData: prevItems };
	      const newRow = {
	        ...src,
	        id: 0,
	        reference_id: 0,
	        vaccine_status: "false",
	        vaccine_date: null,
	        given_outside: 0,
	        vac_site: '',
	        item: '',
	        batch: '',
	        expiry_date: null,
	        remark: '',
	        staff: null,
	        givenon: null,
	      };
	      const newItems = [...prevItems];
	      newItems.splice(index + 1, 0, newRow);
	      return { vaccineData: newItems };
	    });
    }

    // Validates the vaccine rows using the same rules as the Vaccination Record page.
    // Returns { valid, message }.
    validateVaccineData = () => {
        const rows = this.state.vaccineData || [];
        for (const item of rows) {
            const hasItem = item.item !== '' && item.item != null && item.item != 0;
            const givenOutside = item.given_outside == 1 || item.given_outside === 'on';
            const hasGivenOn = item.vaccine_date != null && item.vaccine_date !== '';
            const label = (item.name || 'vaccine');

            if (hasItem && !hasGivenOn) {
                return { valid: false, message: "Given On is required for " + label + " to proceed" };
            }
            if (givenOutside && !hasGivenOn) {
                return { valid: false, message: "Given On is required for " + label + " to proceed" };
            }
            if (!givenOutside && hasGivenOn && !hasItem) {
                return { valid: false, message: "Given Outside or Vaccine name is required for " + label + " to proceed" };
            }
            const hasExtra = (item.remark !== '' && item.remark != null) || (item.batch !== '' && item.batch != null) || (item.expiry_date != null && item.expiry_date !== '');
            if (hasExtra && !givenOutside && !hasItem) {
                return { valid: false, message: "Vaccine name is required for " + label + " to proceed" };
            }
        }
        return { valid: true, message: null };
    }

    // Returns only the vaccines administered to the patient (given on a date, or given
    // outside) in a compact shape for the ANC snapshot / Previous Card. These mirror the
    // records saved in paediatric_vaccination so the Previous Card can render them directly.
    getAdministeredVaccines = () => {
        return (this.state.vaccineData || [])
            .filter(item =>
                (item.vaccine_date != null && item.vaccine_date !== '') ||
                item.given_outside == 1 || item.given_outside === 'on'
            )
            .map(item => ({
                name: item.name,
                type: item.type,
                dose_number: item.dose_number,
                vaccinationId: item.vaccinationId,
                item: (item.item !== '' && item.item != null) ? item.item : '',
                // Resolved vaccine display name (from the row's vaccine_list, else the shared
                // vaccineItemList) so the Previous Card view can show the name, not the id.
                vac_name: (() => {
                    const selId = item.item;
                    if (selId === '' || selId == null) return '';
                    const fromRow = (Array.isArray(item.vaccine_list) ? item.vaccine_list : []).find(v => String(v.id) === String(selId));
                    if (fromRow) return fromRow.name;
                    const fromList = (this.state.vaccineItemList || []).find(v => String(v.id) === String(selId));
                    return fromList ? fromList.name : '';
                })(),
                vaccine_date: item.vaccine_date ? moment(item.vaccine_date).format('YYYY-MM-DD') : null,
                given_outside: (item.given_outside == 1 || item.given_outside === 'on') ? 1 : 0,
                vac_site: item.vac_site || '',
                batch: item.batch || '',
                expiry_date: item.expiry_date || null,
                remark: item.remark || '',
            }));
    }

    // Saves the vaccine rows to the shared vaccination records (same as Vaccination Record page).
    // Only rows that have a given date or are given outside are persisted.
    saveVaccinationData = async () => {
        const reference_id = parseInt(LS_SERVICE.get('call_patient_qms_token_id'));
        // Use the canonical patient id from PATIENT_DATA (same value the Vaccination Record
        // page uses as patient.patient_id) so records sync both ways. Fall back to call_patient_id.
        const patient_id = parseInt(this.state.patientInfo?.patient_id || LS_SERVICE.get('call_patient_id'));

        const vaccination_data = (this.state.vaccineData || [])
            // Only save vaccines added/edited on THIS ANC page: rows not already saved in the
            // shared record (id 0) that have some data entered. Already-saved rows (id > 0)
            // are locked here and belong to the Vaccination Record, so we don't re-save them.
            .filter(item => (item.id == null || item.id === 0))
            .filter(item => (item.vaccine_date != null && item.vaccine_date !== '') || item.given_outside == 1 || item.given_outside === 'on' || (item.item !== '' && item.item != null && item.item != 0))
            .map(item => ({
                id: item.id || 0,
                // vaccine_id maps to emr_vaccination_id on the backend; use dose_id (config row id)
                // like the Vaccination Record page, not the vaccinationId.
                vaccine_id: item.dose_id || item.emr_vaccination_id,
                vaccinationId: item.vaccinationId,
                vacc_id: item.vaccinationId,
                emr_vaccination_id: item.emr_vaccination_id,
                dose_id: item.dose_id,
                dose_number: item.dose_number,
                scheduleDoseNo: item.scheduleDoseNo || item.dose_number,
                name: item.name,
                type: item.type,
                // Include the vaccine name list so the backend can resolve vac_name.
                vaccine_list: Array.isArray(item.vaccine_list) ? item.vaccine_list : [],
                item: (item.item !== '' && item.item != null) ? item.item : '',
                // Resolve the selected vaccine's display name here too (from the row's
                // vaccine_list, else the shared vaccineItemList) so the backend can store
                // vac_name even when the per-row vaccine_list is empty.
                vac_name: (() => {
                    const selId = item.item;
                    if (selId === '' || selId == null) return '';
                    const fromRow = (Array.isArray(item.vaccine_list) ? item.vaccine_list : []).find(v => String(v.id) === String(selId));
                    if (fromRow) return fromRow.name;
                    const fromList = (this.state.vaccineItemList || []).find(v => String(v.id) === String(selId));
                    return fromList ? fromList.name : '';
                })(),
                givenon: item.vaccine_date ? moment(item.vaccine_date).format('YYYY-MM-DD') : '',
                outside: (item.given_outside == 1 || item.given_outside === 'on') ? 'on' : 0,
                vac_site: item.vac_site || '',
                batch: item.batch || '',
                expiry_date: item.expiry_date || null,
                remark: item.remark || '',
                duedate: item.duedate || null,
                dob: this.state.patientInfo?.dob || null,
                start_age: item.startAge,
                duration: item.startAgeDuration,
                reference_id: reference_id,
                reference_type: 0,
                creted_by: LS_SERVICE.get('staff_id'),
            }));

        if (vaccination_data.length === 0) {
            return true;
        }

        const PARAMS = {
            vaccination_data: vaccination_data,
            patient_id: patient_id,
            encounter_id: reference_id,
            reference_type: 0,
        };

        try {
            await Axios.post(VaccinationAdd, PARAMS);
            return true;
        } catch (error) {
            notification.error({
                message: 'Something went wrong! Unable to save vaccination data',
                placement: 'topRight'
            });
            return false;
        }
    }

    // Fetches previously saved vaccines and merges given-on/outside/batch/etc. into vaccineData.
    getSavedVaccinationRecords = async () => {
        // Use the canonical patient id from PATIENT_DATA (same value the Vaccination Record
        // page uses) so we read the same shared vaccination rows. Fall back to call_patient_id.
        const patient_id = parseInt(this.state.patientInfo?.patient_id || LS_SERVICE.get('call_patient_id'));
        try {
            const response = await Axios.post(VaccinationRecordList, qs.stringify({ patient_id: patient_id }));
            // VaccinationRecordList returns the records as the object's values (keyed 0,1,2...),
            // matching how VaccinationRecord.js consumes it via Object.values(response.data).
            const saved = Object.values(response.data || {}).filter(v => v && typeof v === 'object' && v.vacc_id !== undefined);
            if (!saved || saved.length === 0) return;

            await this.setState(prevState => {
                const merged = prevState.vaccineData.map(v => {
                    const match = saved.find(s => s.vacc_id == v.vaccinationId && s.dose_number == v.dose_number);
                    if (match) {
                        return {
                            ...v,
                            id: match.id || 0,
                            reference_id: match.reference_id,
                            item: (match.item_id != null && match.item_id !== '') ? String(match.item_id) : '',
                            vaccine_date: match.given_on ? moment(match.given_on).format('YYYY-MM-DD') : null,
                            given_outside: match.given_outside ? 1 : 0,
                            // Normalise site to a string so the Select value matches its String option ids.
                            vac_site: (match.vac_site != null && match.vac_site !== '') ? String(match.vac_site) : '',
                            batch: match.batch || '',
                            expiry_date: match.expiry_date ? moment(match.expiry_date).format('YYYY-MM-DD') : null,
                            remark: match.remarks || '',
                            vaccine_status: (match.given_on || match.given_outside) ? "true" : "false",
                            // Staff who recorded this dose (for the INFO popover) + given date + recorded-on.
                            staff: match.docDetails || null,
                            givenon: match.given_on || null,
                            created_at: match.createdAt || match.created_at || null,
                        };
                    }
                    return v;
                });
                return { vaccineData: merged };
            });
        } catch (error) {
            // Non-blocking.
        }
    }

    // "Given Outside?" checkbox toggle for a vaccine row.
    handleVaccineGivenOutside = async (event, index) => {
	    const value = event.target.checked ? 1 : 0;
	    await this.setState(prevState => {
	      const prevItems = [...prevState.vaccineData];
	      prevItems[index]['given_outside'] = value;
	      return { vaccineData: prevItems };
	    });
    }

    // Expiry date update for a vaccine row.
    handleVaccineExpiryDate = async (date, dateString, index) => {
	    await this.setState(prevState => {
	      const prevItems = [...prevState.vaccineData];
	      prevItems[index]['expiry_date'] = date ? moment(date).format("YYYY-MM-DD") : null;
	      return { vaccineData: prevItems };
	    });
    }

    // Builds the obs_gyane_data snapshot persisted on the ANC card. A reference id can
    // accumulate multiple mother-parameter readings; ensure the snapshot always carries the
    // FULL history (mother_parameter_data_all) so the closed card / print can list every
    // reading. Falls back to wrapping the single latest reading when the history array is
    // absent, so nothing is lost even for older data.
    buildObsGyaneSnapshot = () => {
        const cpd = this.state.currentPregnancyData;
        if (!cpd) return cpd;
        const snapshot = { ...cpd };
        const hasAll = Array.isArray(snapshot.mother_parameter_data_all) && snapshot.mother_parameter_data_all.length > 0;
        if (!hasAll) {
            // No explicit history array: derive it from the latest single reading (if any)
            // so mother_parameter_data_all is always present in the saved snapshot.
            if (snapshot.mother_parameter_data && Object.keys(snapshot.mother_parameter_data).length > 0) {
                snapshot.mother_parameter_data_all = [snapshot.mother_parameter_data];
            } else {
                snapshot.mother_parameter_data_all = [];
            }
        }
        return snapshot;
    }

    getPatientObsGyaneData = async () => {
	    let Params = {
	      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
	      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
	      reference_type: 0,
	      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
	      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
	      source: 'OP',
	    }
	    await Axios.post(Get_Obs_Gyane_Data,Params).then(async res => {
			// The obs/gynae row keeps pregnant="1" even after the pregnancy is closed (closing
			// only closes the ANC card and clears Patient.is_pregnant). The current-pregnancy
			// section must reflect the live pregnancy status, so treat the patient as having a
			// current pregnancy only when both the obs/gynae data says pregnant AND the
			// patient-level flag is still set (i.e. the pregnancy has not been closed).
			const patientStillPregnant = LS_SERVICE.get('PATIENT_PREGNANT_STATUS') == "1";
			if(res.data.status == true && res.data.data?.pregnant == "1" && patientStillPregnant)
			{
				await this.setState({
					currentPregnancyData : res.data.data
				});

				if(this.state.currentPregnancyData)
				{
					if(this.state.currentPregnancyData?.pregnancy_risk_factor != null && this.state.currentPregnancyData?.pregnancy_risk_factor != null != "")
					{
						let pregnancy_risk_factor_saved = this.state.currentPregnancyData?.pregnancy_risk_factor.split(',');
						let pregnancy_risk_factor_selected = [];
						for (var i = 0; i < pregnancy_risk_factor_saved.length; i++) {
							pregnancy_risk_factor_selected.push(parseInt(pregnancy_risk_factor_saved[i]));
						}
						await this.setState({
							pregnancy_risk_factor : pregnancy_risk_factor_selected,
							pregnancy_risk_factor_selected : pregnancy_risk_factor_selected
						});
                        setTimeout(() => {
    						this.ancFormRef?.current?.setFieldsValue({
    							pregnancy_risk_factor : pregnancy_risk_factor_selected,
    							pregnancy_risk_factor_selected : pregnancy_risk_factor_selected
    						});
                        }, 0);
					}

					await this.setState({
			            pregnancy_risk_factor_management_remarks : this.state.currentPregnancyData?.pregnancy_risk_factor_management_remarks || null,
          			});

                    setTimeout(() => {
    					this.ancFormRef?.current?.setFieldsValue({
    						pregnancy_risk_factor_management_remarks : this.state.currentPregnancyData?.pregnancy_risk_factor_management_remarks || null,
    					});
                    }, 0);
				}     
			}
			else
			{
				// Not currently pregnant (no data, or pregnancy closed): clear the current
				// pregnancy data so the current ANC/pregnancy section stops rendering.
				await this.setState({ currentPregnancyData : null });
			}
	    })
	    .catch(error => {
	      notification.error({
	        message: 'Something went wrong! Unable to fetch the data',
	        placement: 'topRight'
	      })
	    })
  	}

  	getPatientAncDetails = async () => {
	    let Params = {
	      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
	      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
	      reference_type: 0,
	      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
	      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
	      source: 'OP',
	    }
	    await Axios.post(Get_Anc_Details,Params).then(async res => {
			if(res.data.status == true)
			{
				let anc_details_data = res.data?.data;
		        if(anc_details_data)
		        {
		        	// The ANC card id is used to key the Investigations (test/procedure) results.
		        	await this.setState({ anc_id: anc_details_data?.id || null });
		        	// The vaccine checklist is always built from the vaccine config (getVaccineData);
		        	// the actual given/saved data comes from the shared Vaccination Record fetch
		        	// (getSavedVaccinationRecords), NOT from the ANC saved blob. This keeps the ANC
		        	// list in sync with the Vaccination Record page.
		        	await this.getVaccineData();
                    
					// Title/Description rows come back from the backend as `test_procedures_data`
					// (patient_obs_gyane_anc_test_procedure_data). Fall back to a single empty row.
					const loadedTestProcedureDatas = Array.isArray(anc_details_data?.test_procedures_data) && anc_details_data.test_procedures_data.length > 0
						? anc_details_data.test_procedures_data.map(row => ({ id: row.id, title: row.title || '', description: row.description || '', created_by: row.created_by || null }))
						: [{ title: '', description: '' }];

					await this.setState({
						immuno_remarks : anc_details_data?.immuno_remarks || null,
						investigation_remarks : anc_details_data?.investigation_remarks || null,
						test_procedures_data : loadedTestProcedureDatas,
						pregnancy_year : anc_details_data?.pregnancy_year || null,
						delivery_mode : anc_details_data?.delivery_mode || null,
						pregnancy_type : anc_details_data?.pregnancy_type || null,
						delivery_indication_for_c_section : anc_details_data?.delivery_indication_for_c_section || null,
						delivery_details : anc_details_data?.delivery_details || null,
					});

                    setTimeout(() => {
    					this.ancFormRef?.current?.setFieldsValue({
    						immuno_remarks : anc_details_data?.immuno_remarks || null,
    						pregnancy_year : anc_details_data?.pregnancy_year || null,
    						delivery_mode : anc_details_data?.delivery_mode || null,
    						pregnancy_type : anc_details_data?.pregnancy_type || null,
    						delivery_indication_for_c_section : anc_details_data?.delivery_indication_for_c_section || null,
    						delivery_details : anc_details_data?.delivery_details || null,
    					});
                    }, 0);
		        }

		        if(anc_details_data?.pregnancy_type == '2')
		        {
		        	let saved_multiple_pregnancies = [];
		        	if(anc_details_data?.multiple_pregnancies.length > 0)
		        	{
		        		anc_details_data?.multiple_pregnancies.forEach(ele => {
			              let obj = { delivery_type : ele.delivery_type, delivery_place : ele.delivery_place, delivery_outcome : ele.delivery_outcome, delivery_bith_date_time : ele.delivery_bith_date_time != null ? moment(ele.delivery_bith_date_time) : null, delivery_gender : ele.delivery_gender, delivery_birth_weight : ele.delivery_birth_weight, delivery_birth_height : ele.delivery_birth_height, delivery_birth_head_cc : ele.delivery_birth_head_cc, delivery_congenital_abnormality : ele.delivery_congenital_abnormality == "true" ? true : false, delivery_congenital_abnormality_remarks : ele.delivery_congenital_abnormality_remarks }
			              saved_multiple_pregnancies.push(obj);
			            });
		        	}
		        	await this.setState({
			            multiple_pregnancies : saved_multiple_pregnancies
		          	});

                    setTimeout(() => {
    		          	this.ancFormRef?.current?.setFieldsValue({
    			            multiple_pregnancies : saved_multiple_pregnancies
    		          	});
                    }, 0);
		        }
		        else
		        {
		        	await this.setState({
			            delivery_type : anc_details_data?.delivery_type || null,
			            delivery_place : anc_details_data?.delivery_place || null,
			            delivery_outcome : anc_details_data?.delivery_outcome || null,
			            delivery_bith_date_time : (anc_details_data?.delivery_bith_date_time && anc_details_data.delivery_bith_date_time != null) ? moment(anc_details_data.delivery_bith_date_time).format('YYYY-MM-DD HH:mm'): null,
			            delivery_gender : anc_details_data?.delivery_gender || null,
			            delivery_birth_weight : anc_details_data?.delivery_birth_weight || null,
			            delivery_birth_height : anc_details_data?.delivery_birth_height || null,
			            delivery_birth_head_cc : anc_details_data?.delivery_birth_head_cc || null,
			            delivery_congenital_abnormality_remarks : (anc_details_data?.delivery_congenital_abnormality == "true" && (anc_details_data?.delivery_congenital_abnormality_remarks != null && anc_details_data?.delivery_congenital_abnormality_remarks != "")) ? anc_details_data?.delivery_congenital_abnormality_remarks : null,
			            delivery_congenital_abnormality : anc_details_data?.delivery_congenital_abnormality == "true" ? true : false,
			            multiple_pregnancies: [],
		          	});

                    setTimeout(() => {
    					this.ancFormRef?.current?.setFieldsValue({
    						delivery_type : anc_details_data?.delivery_type || null,
    			            delivery_place : anc_details_data?.delivery_place || null,
    			            delivery_outcome : anc_details_data?.delivery_outcome || null,
    			            delivery_bith_date_time : (anc_details_data?.delivery_bith_date_time && anc_details_data.delivery_bith_date_time != null) ? moment(anc_details_data.delivery_bith_date_time) : null,
    			            delivery_gender : anc_details_data?.delivery_gender || null,
    			            delivery_birth_weight : anc_details_data?.delivery_birth_weight || null,
    			            delivery_birth_height : anc_details_data?.delivery_birth_height || null,
    			            delivery_birth_head_cc : anc_details_data?.delivery_birth_head_cc || null,
    			            delivery_congenital_abnormality_remarks : (anc_details_data?.delivery_congenital_abnormality == "true" && (anc_details_data?.delivery_congenital_abnormality_remarks != null && anc_details_data?.delivery_congenital_abnormality_remarks != "")) ? anc_details_data?.delivery_congenital_abnormality_remarks : null,
    			            delivery_congenital_abnormality : anc_details_data?.delivery_congenital_abnormality == "true" ? true : false,
    			            multiple_pregnancies: [],
    					});
                    }, 0);
		        }
			}
			else
	        {
	        	// No OPEN ANC card (e.g. the pregnancy was just closed). Clear the current-card
	        	// state so the closed pregnancy's details stop showing without a manual reload.
	        	await this.setState({
	        		anc_id: null,
	        		pregnancy_year : null,
	        		delivery_mode : null,
	        		pregnancy_type : null,
	        		delivery_type : null,
	        		delivery_place : null,
	        		delivery_outcome : null,
	        		delivery_bith_date_time : null,
	        		delivery_gender : null,
	        		delivery_birth_weight : null,
	        		delivery_birth_height : null,
	        		delivery_birth_head_cc : null,
	        		delivery_congenital_abnormality : false,
	        		delivery_congenital_abnormality_remarks : null,
	        		delivery_indication_for_c_section : null,
	        		delivery_details : null,
	        		multiple_pregnancies : [],
	        	});
	        	await this.getVaccineData();
	        }
	    })
	    .catch(error => {
	      notification.error({
	        message: 'Something went wrong! Unable to fetch the data',
	        placement: 'topRight'
	      })
	    })
  	}

  	getPatientAncPreviousDetails = async () => {
	    let Params = {
	      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
	      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
	    }
	    await Axios.post(Get_Anc_Previous_Details,Params).then(async res => {
			if(res.data.status == true)
			{
				await this.setState({
					prevAncCardData : res.data.data
				})
			}
			else
			{
				await this.setState({
					prevAncCardData : []
				})
			}
	    })
	    .catch(error => {
	      notification.error({
	        message: 'Something went wrong! Unable to fetch the data',
	        placement: 'topRight'
	      })
	    })
  	}

    getPreviousMotherHistory = async () => {
        const patient_id = parseInt(LS_SERVICE.get('PATIENT_REG_DATA')?.registrationid);
        if (!Number.isInteger(patient_id) || patient_id <= 0) {
            return;
        }

        try {
            const response = await Axios.post(Get_Previous_Mother_Fetus_History, { patient_id });
            if (response?.data?.status === true) {
                const history = response.data.data || {};
                await this.setState({
                    previousMotherParameters: Array.isArray(history.mother_parameter_data_all)
                        ? history.mother_parameter_data_all
                        : [],
                    previousMotherFetusData: Array.isArray(history.mother_fetus_data)
                        ? history.mother_fetus_data
                        : [],
                });
            } else {
                await this.setState({ previousMotherParameters: [], previousMotherFetusData: [] });
            }
        } catch (error) {
            notification.error({
                message: 'Something went wrong! Unable to fetch previous mother history',
                placement: 'topRight'
            });
        }
    };

    openPreviousMotherParameterHistory = async () => {
        await this.getPreviousMotherHistory();
        this.setState({ previousMotherParameterModalVisible: true });
    };

    openPreviousMotherFetusHistory = async () => {
        await this.getPreviousMotherHistory();
        this.setState({ previousMotherFetusModalVisible: true });
    };

    // True only when No. of Fetus holds a valid value (1-9). Used to gate the
    // "+ FETAL PARAMETER" button and the Close Pregnancy action.
    hasNoOfFetus = () => {
        const value = this.state.currentPregnancyData?.no_of_fetus;
        return /^[1-9]$/.test(String(value ?? '').trim());
    };

    // Close Pregnancy guard: No. of Fetus must be filled before closing the pregnancy.
    // Blocks opening the Delivery Details modal and prompts the user when it is blank.
    handleClosePregnancy = () => {
        const fetusFilled = this.hasNoOfFetus();
        if (!fetusFilled) {
            notification.error({
                message: 'Please fill No. of Fetus value first to close the pregnancy.',
                placement: 'topRight'
            });
            return;
        }
        this.setState({ deliveryDetailsModalVisible: true });
    };

   getListValue(selectedValue, OptionObj = null) {
        if (selectedValue == 0 || selectedValue === null) {
            return "-";
        } else if (OptionObj) {
            return OptionObj[selectedValue];
        } else {
            return selectedValue;
        }
    }

  	// Renders every mother-parameter reading for this reference id (oldest first).
  	// Uses mother_parameter_data_all when present; falls back to the single latest object.
  	showMotherParametersRows() {
        const cpd = this.state.currentPregnancyData;
        let rows = Array.isArray(cpd?.mother_parameter_data_all) ? cpd.mother_parameter_data_all : [];
        if (rows.length === 0 && cpd?.mother_parameter_data) {
            rows = [cpd.mother_parameter_data];
        }
        if (rows.length === 0) {
            return (<tr><td className="text-center" colSpan="11">No data available</td></tr>);
        }
        // Show the latest saved record first (highest id / newest on top).
        const orderedRows = rows.every(r => r && r.id != null)
            ? [...rows].sort((a, b) => b.id - a.id)
            : [...rows].reverse();
        return orderedRows.map((data, i) => (
            <tr key={data.id || i}>
                <td className="text-center">
                    {(data.updatedAt || data.createdAt) ? moment(data.updatedAt || data.createdAt).format("D MMM, YYYY | h:mm A") : '-'}
                    {data.mother_remarks && data.mother_remarks !== null ? (
                        <Tooltip title={data.mother_remarks}>
                            <InfoCircleOutlined style={{ cursor: 'pointer', color: '#1a73e8', fontSize: '14px', marginLeft: '6px' }} />
                        </Tooltip>
                    ) : null}
                </td>
                <td className="text-center">{data.saved_by_doctor_name || '-'}</td>
                <td className="text-center">{data.pog || '-'}</td>
                <td className="text-center">{data.weight || '-'}</td>
                <td className="text-center">{data.blood_pressure || '-'}</td>
                <td className="text-center">{data.pulse_rate || '-'}</td>
                <td className="text-center">{data.fundal_height || '-'}</td>
                <td className="text-center">{data.edema || '-'}</td>
                <td className="text-center">{data.pallor || '-'}</td>
                <td className="text-center">{data.cervix_exam || '-'}</td>
                <td className="text-center">{data.preterm_labour || '-'}</td>
            </tr>
        ));
    }

  	// Renders a SEPARATE table per fetus_no: one table for Fetus 1, another for Fetus 2, etc.
  	// Within each table the records are shown latest first (highest id on top).
  	showFetalParameterTables() {
        const rows = Array.isArray(this.state.currentPregnancyData?.mother_fetus_data) ? this.state.currentPregnancyData.mother_fetus_data : [];
        if (rows.length === 0) {
            return (
                <div className='row mt-3'>
                    <table className="table table-bordered mt-2">
                        <tbody>
                            <tr><td className="text-center">No data available</td></tr>
                        </tbody>
                    </table>
                </div>
            );
        }

        // Group rows by fetus_no (fall back to 1 when missing).
        const groups = {};
        rows.forEach((r) => {
            const key = (r.fetus_no != null && r.fetus_no !== '') ? parseInt(r.fetus_no) : 1;
            if (!groups[key]) groups[key] = [];
            groups[key].push(r);
        });

        const fetusNos = Object.keys(groups).map(k => parseInt(k)).sort((a, b) => a - b);

        return fetusNos.map((fno) => {
            // Latest saved first within this fetus.
            const fetusRows = [...groups[fno]].sort((a, b) => (b.id || 0) - (a.id || 0));
            return (
                <div className='row mt-3' key={'fetus-' + fno}>
                    <div className='col-12'>
                        <span className='title'>{'Fetus ' + fno}</span>
                    </div>
                    <table className="table table-bordered mt-2">
                        <thead>
                            <tr>
                                <td width="12%">DATE &amp; TIME</td>
                                <td width="12%">SAVED BY</td>
                                <td width="11%">FETAL MOVEMENT</td>
                                <td width="9%">FHR(B/Min)</td>
                                <td width="11%">PRESENTATION</td>
                                <td width="11%">RELATION OF PP TO BRIM</td>
                                <td width="9%">HEAD CC (CM)</td>
                                <td width="9%">ABDOMINAL CC (CM)</td>
                                <td width="9%">FEMUR LENGTH(CM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            {fetusRows.map((data, i) => (
                                <tr key={data.id || i}>
                                    <td className="text-center">{(data.updatedAt || data.createdAt) ? moment(data.updatedAt || data.createdAt).format("D MMM, YYYY | h:mm A") : '-'}</td>
                                    <td className="text-center">{data.saved_by_doctor_name || '-'}</td>
                                    <td className="text-center">{this?.getListValue(data.fetal_movement, FETAL_MOVEMENT)}</td>
                                    <td className="text-center">{data.fetal_heart_rate || '-'}</td>
                                    <td className="text-center">{this?.getListValue(data.presentation, PRESENTATION)}</td>
                                    <td className="text-center">{this?.getListValue(data.relationship_of_pp_to_brim, RELATIONSHIP_TO_PP_BRIM)}</td>
                                    <td className="text-center">{data.head_cc || '-'}</td>
                                    <td className="text-center">{data.abdominal_cc || '-'}</td>
                                    <td className="text-center">{data.femur_length || '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        });
    }
    
    render() {
    	const { patientInfo } = this.state;
    	const { ss_configuration, consult_type, prevAncCardData } = this.state;
        const cpd = this.state.currentPregnancyData;
        const headerLmp = cpd?.menstural_data?.lmp || null;
        const headerEdd = cpd?.edd_by_lmp || null;
        const headerObstetric = cpd?.obstetric_data;
        // Full GPALE score (Gravidity, Parity, Abortion, Live birth, Ectopic).
        const headerGpale = headerObstetric
            ? [
                (headerObstetric.gravidity != null && headerObstetric.gravidity !== '') ? 'G' + headerObstetric.gravidity : '',
                (headerObstetric.parity != null && headerObstetric.parity !== '') ? 'P' + headerObstetric.parity : '',
                (headerObstetric.abortion != null && headerObstetric.abortion !== '') ? 'A' + headerObstetric.abortion : '',
                (headerObstetric.live_birth != null && headerObstetric.live_birth !== '') ? 'L' + headerObstetric.live_birth : '',
                (headerObstetric.ectopic != null && headerObstetric.ectopic !== '') ? 'E' + headerObstetric.ectopic : '',
              ].filter(Boolean).join(' ')
            : '';
        const headerGaToday = this.getGAToday(headerLmp, headerEdd);
        // Show Pregnancy Active / Close Pregnancy based on the PATIENT-level flag, which is
        // set to 0 when the pregnancy is closed (delivery details saved). Kept live via
        // pregnantService; falls back to the patient record's is_pregnant.
        const isHeaderPregnant = this.state.isPatientPregnant || this.state.patientInfo?.is_pregnant == "1";
        return (
            <>
                <AsideLeft />
                <MyHcSpeechRecognition />
                <div className="content-wrapper">
                    <div className="container-fluid emrfrm anc-container mb-4 ">
                        <div className='row'>
                            <div className='col-12 mb-3'>
                                <div className="float-left">
                                    <h1 className="page-title mb-0">ANC Card</h1>
                                </div>
                            </div>
                        </div>
                        {
                            isHeaderPregnant
                            ?
                                <div className='row'>
                                    <div className='col-12'>
                                        <div className='card p-3' style={{ backgroundColor: '#fff' }}>
                                            <div className='row align-items-center flex-nowrap'>
                                                <div className='col-auto'>
                                                    <span className='heading font-weight-bold'>LMP:&nbsp;</span>
                                                    <span className='patient_name'>{headerLmp ? moment(headerLmp).format('DD MMM, YYYY') : '-'}</span>
                                                </div>
                                                <div className='col-auto'>
                                                    <span className='heading font-weight-bold'>EDD BY LMP:&nbsp;</span>
                                                    <span className='patient_name'>{headerEdd ? moment(headerEdd).format('DD MMM, YYYY') : '-'}</span>
                                                </div>
                                                <div className='col-auto'>
                                                    <span className='heading font-weight-bold'>Gravidity:&nbsp;</span>
                                                    <span className='patient_name'>
                                                        {headerGpale !== '' ? headerGpale : '-'}
                                                    </span>
                                                </div>
                                                <div className='col-auto'>
                                                    <span className='heading font-weight-bold'>GA Today:&nbsp;</span>
                                                    <span className='patient_name' style={{ color: '#1a73e8' }}>{headerGaToday || '-'}</span>
                                                </div>
                                                <div className='col text-right'>
                                                    <button type="button" className="btn small px-3 mr-2" style={{ color: '#2e7d32', backgroundColor: '#e6f4ea', border: '1px solid #b7dfc2', cursor: 'default' }}>
                                                        <span style={{ display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#2e7d32', marginRight: '6px' }}></span>
                                                        Pregnancy Active
                                                    </button>
                                                    <button type="button" className="btn btn-primary small px-3" onClick={this.handleClosePregnancy}>Close Pregnancy</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            :
                            null
                        }

                        {
                        	/* Active (current) ANC card first, shown expanded on top */
                        	LS_SERVICE.get('PATIENT_PREGNANT_STATUS') == "1" 
                        	?
                            <>
                            	<div className='row mt-3'>
                                    <div className='col-12'>
                                        <div className='card anc-carddarkgrey'>
                                            <span className='newancdet'>New ANC Card Details</span>
                                        </div>
                                    </div>
                                </div>
                                <Form
                                    layout="vertical"
                                    className="emrfrm"
                                    ref={this.ancFormRef}
                                    onFinish={this.onFinishAncForm}
                                    id="saveform"
                                >
                                	{
                                    	this.state.currentPregnancyData?.menstural_data 
                                    	?
	                                        <>
	                                            <div className='row mt-3'>
	                                                <div className='col-12'>
	                                                    <h6 className='font-weight-bold mb-0'>Menstrual History</h6>
	                                                </div>
	                                            </div>
	                                            <div className='row mt-3'>
	                                                <div className='col-3'>
	                                                    <div className='text-muted mb-1'>LMP</div>
	                                                    <div className='font-weight-bold'>
	                                                    	{(this.state.currentPregnancyData?.menstural_data?.lmp && this.state.currentPregnancyData?.menstural_data.lmp != null) ? moment(this.state.currentPregnancyData?.menstural_data.lmp).format('DD MMM, YYYY'): '-'}
                                                    	</div>
	                                                </div>
	                                                <div className='col-3'>
	                                                    <div className='text-muted mb-1'>Cycle Length</div>
	                                                    <div className='font-weight-bold'>
	                                                    	{(this.state.currentPregnancyData?.menstural_data?.cycle_length != null && this.state.currentPregnancyData?.menstural_data?.cycle_length != "") ? this.state.currentPregnancyData?.menstural_data?.cycle_length + " days" : '-'}
	                                                    </div>
	                                                </div>
	                                                <div className='col-3'>
	                                                    <div className='text-muted mb-1'>GA Today</div>
	                                                    <div>
	                                                        {
	                                                            this.getGAToday(this.state.currentPregnancyData?.menstural_data?.lmp, this.state.currentPregnancyData?.corrected_edd || this.state.currentPregnancyData?.edd_by_lmp)
	                                                            ?
	                                                                <span className='px-3 py-1 rounded font-weight-bold' style={{ backgroundColor: '#e8f0fe', color: '#1a73e8' }}>
	                                                                    {this.getGAToday(this.state.currentPregnancyData?.menstural_data?.lmp, this.state.currentPregnancyData?.corrected_edd || this.state.currentPregnancyData?.edd_by_lmp)} (from LMP)
	                                                                </span>
	                                                            :
	                                                                <span className='font-weight-bold'>-</span>
	                                                        }
	                                                    </div>
	                                                </div>
	                                                <div className='col-3'>
	                                                    <div className='text-muted mb-1'>Last Updated</div>
	                                                    <div className='font-weight-bold'>
	                                                        {this.state.currentPregnancyData?.menstural_data?.updatedAt ? moment(this.state.currentPregnancyData?.menstural_data?.updatedAt).format("D MMM, YYYY | h:mm A") : '-'}
	                                                    </div>
	                                                </div>
	                                            </div>
	                                        </>
                                        : 
                                        null
                                    }
                                    {
                                    	this.state.currentPregnancyData ?
                                        <>
                                            <div className='row mt-3'>
                                                <div className='col-12'>
                                                    <h6 className='font-weight-bold mb-0'>Obstetric History</h6>
                                                </div>
                                            </div>
                                            <div className='row mt-3'>
                                                <div className='col-3'>
                                                    <div className='text-muted mb-1'>EDD by LMP</div>
                                                    <div className='font-weight-bold'>{this.state.currentPregnancyData?.edd_by_lmp ? moment(this.state.currentPregnancyData?.edd_by_lmp).format("D MMM, YYYY") : '-'}</div>
                                                </div>
                                                <div className='col-3'>
                                                    <div className='text-muted mb-1'>Corrected EDD</div>
                                                    <div>
                                                        {
                                                            (this.state.currentPregnancyData?.corrected_edd != null && this.state.currentPregnancyData?.corrected_edd != "")
                                                            ?
                                                                <span className='px-3 py-1 rounded font-weight-bold text-white' style={{ backgroundColor: '#c0392b' }}>
                                                                    {moment(this.state.currentPregnancyData?.corrected_edd).format("D MMM, YYYY")}
                                                                </span>
                                                            :
                                                                <span className='font-weight-bold'>-</span>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='col-3'>
                                                    <div className='text-muted mb-1'>Lactating</div>
                                                    <div className='font-weight-bold'>{(this.state?.currentPregnancyData?.lactating && this.state?.currentPregnancyData?.lactating == "1") ? 'Yes' : 'No'}</div>
                                                </div>
                                                <div className='col-3'>
                                                    <div className='text-muted mb-1'>Gravidity / Parity</div>
                                                    <div>
                                                    {
                                                        this.state?.currentPregnancyData?.obstetric_data
                                                        ?
                                                            <span className="bg-grey py-1 px-3 rounded font-weight-bold">
                                                                {(this.state?.currentPregnancyData?.obstetric_data.gravidity != null && this.state?.currentPregnancyData?.obstetric_data.gravidity !== '') ? 'G'+this.state?.currentPregnancyData?.obstetric_data.gravidity+' ' : ''}{(this.state?.currentPregnancyData?.obstetric_data.parity != null && this.state?.currentPregnancyData?.obstetric_data.parity !== '') ? 'P'+this.state?.currentPregnancyData?.obstetric_data.parity+' ' : ''}{(this.state?.currentPregnancyData?.obstetric_data.abortion != null && this.state?.currentPregnancyData?.obstetric_data.abortion !== '') ? 'A'+this.state?.currentPregnancyData?.obstetric_data.abortion+' ' : ''}{(this.state?.currentPregnancyData?.obstetric_data.live_birth != null && this.state?.currentPregnancyData?.obstetric_data.live_birth !== '') ? 'L'+this.state?.currentPregnancyData?.obstetric_data.live_birth+' ' : ''}{(this.state?.currentPregnancyData?.obstetric_data.ectopic != null && this.state?.currentPregnancyData?.obstetric_data.ectopic !== '') ? 'E'+this.state?.currentPregnancyData?.obstetric_data.ectopic+' ' : ''}
                                                            </span>
                                                        :
                                                        <span className='font-weight-bold'>-</span>
                                                    }
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                            	this.state.currentPregnancyData?.obstetric_remarks && this.state.currentPregnancyData?.obstetric_remarks != "" && this.state.currentPregnancyData?.obstetric_remarks != null 
                                            	?
		                                            <div className='row mt-3'>
		                                                <div className='col-2'>
		                                                    <span className='title'>Obstetric Remarks</span>
		                                                </div>
		                                                <div className='col-10'>
		                                                    <pre style={{ fontSize: "15px", border: "none" }}>{this.state.currentPregnancyData?.obstetric_remarks}</pre> 
		                                                </div>
		                                            </div>
                                            	: 
                                            	null
                                            }
                                        </>
                                        : 
                                        null
                                    }

                                    <div className='row mt-3'>
                                        <div className='col-12'>
                                            <span className='title'> Allergies</span>
                                        </div>
                                        <table className="table table-bordered mt-3" >
                                            <thead>
                                                <tr>
                                                    <td width="28%">ALLERGY NAME</td>
                                                    <td width="22%">REACTION</td>
                                                    <td width="15%">DURATION</td>
                                                    <td width="15%">INTENSITY</td>
                                                    <td width="15%">INFORMED BY</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.current_allergies != undefined && this.state.current_allergies.length > 0 ?
                                                    this.state.current_allergies.map((obj) => (
                                                        <tr>
                                                            <td>{obj.allergy_name}</td>
                                                            <td>{obj.reaction ? obj.reaction : '-'}</td>
                                                            <td>{obj.duration ? obj.duration + ' ' + DURATION_TYPE[obj.durationType] : '-'}</td>
                                                            <td>{obj.intensity === 0 ? "Low" : obj.intensity === 1 ? "Medium" : obj.intensity === 2 ? "High" : '-'}</td>
                                                            <td>{obj?.informedBy == 0 || obj?.informedBy == 1 ? INFORMED_BY[obj?.informedBy] : "-"}</td>
                                                        </tr>
                                                    ))
                                                    : <tr><td colspan="5">No data available</td></tr>}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className='row mt-3'>
                                        <div className='col-12'>
                                            <span className='title'>Existing Condition</span>
                                        </div>
                                        <table className="table table-bordered mt-3" >
                                            <thead>
                                                <tr>
                                                    <td width="30%">CONDITIONS</td>
                                                    <td width="20%">DURATION</td>
                                                    <td width="20%">ON MEDICATION</td>
                                                    <td width="30%">MEDICINE NAME</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.current_conditions != undefined && this.state.current_conditions.length > 0 ?
                                                    this.state.current_conditions.map((c, i) => (
                                                        <tr>
                                                            <td>{c.condition_description}</td>
                                                            <td>{(c.duration) ? `${c.duration} ${DURATION_TYPE[c.durationType]}` : '-'}</td>
                                                            <td>{MEDICATION_ON[c.onMedication] ? MEDICATION_ON[c.onMedication] : '-'}</td>
                                                            <td>{c.medicineName || "NA"}</td>
                                                        </tr>
                                                    ))
                                                    : <tr><td colspan="4">No data available</td></tr>}
                                            </tbody>
                                        </table>
                                    </div>
                                    {
                                        /* When no physical exam data exists yet, still offer a way to add the first records. */
                                        ((!this.state.currentPregnancyData?.mother_parameter_data && (!this.state.currentPregnancyData?.mother_fetus_data || this.state.currentPregnancyData?.mother_fetus_data.length == 0)) && (this.state.allowEdit || this.state.previousMotherParameters.length > 0 || this.state.previousMotherFetusData.length > 0))
                                    ?
	                                        <div className='row mt-3 align-items-center'>
	                                            <div className='col-4'>
	                                                <span className='title'> Physical Examination</span>
	                                            </div>
	                                            <div className='col-4 text-center'>
	                                                <a href='javascript:void(0)' className='text-primary mr-3' onClick={this.openPreviousMotherParameterHistory}>
	                                                    Previous Mother Parameter Details
	                                                </a>
	                                                <a href='javascript:void(0)' className='text-primary' onClick={this.openPreviousMotherFetusHistory}>
	                                                    Previous Mother Fetus Details
	                                                </a>
	                                            </div>
	                                            <div className='col-4 text-right'>
	                                                {
	                                                    this.state.allowEdit
	                                                    ?
	                                                        <>
	                                                            <a className='btn btn-outline-primary small px-2 mr-2' onClick={() => this.setState({ motherParameterModalVisible: true })}>
	                                                                + MOTHER PARAMETER
	                                                            </a>
	                                                            {
	                                                                this.hasNoOfFetus()
	                                                                ?
	                                                                    <a className='btn btn-outline-primary small px-2' onClick={() => this.setState({ fetusModalVisible: true })}>
	                                                                        + FETAL PARAMETER
	                                                                    </a>
	                                                                : null
	                                                            }
	                                                        </>
	                                                    : null
	                                                }
	                                            </div>
	                                        </div>
                                    	:
                                    	null
                                    }
                                    {
                                    	this.state.currentPregnancyData?.mother_parameter_data || (this.state.currentPregnancyData?.mother_fetus_data && this.state.currentPregnancyData?.mother_fetus_data.length > 0) 
                                    	?
	                                        <>
	                                            <div className='row mt-3'>
	                                                <div className='col-12'>
	                                                    <span className='title'> Physical Examination</span>
	                                                </div>
	                                            </div>
	                                            <div className='row mt-3 align-items-center'>
	                                                <div className='col-4 d-flex align-items-center'>
	                                                    <span className='title'>Mother's Parameters</span>
	                                                </div>
	                                                <div className='col-4 text-center'>
	                                                    {
	                                                        this.state.previousMotherParameters.length > 0
	                                                        ?
	                                                            <a href='javascript:void(0)' className='text-primary' onClick={this.openPreviousMotherParameterHistory}>
	                                                                Previous Mother Parameter Details
	                                                            </a>
	                                                        :
	                                                        null
	                                                    }
	                                                </div>
	                                                <div className='col-4 text-right'>
	                                                    {
	                                                        this.state.allowEdit
	                                                        ?
	                                                            <a className='btn btn-outline-primary small px-2' onClick={() => this.setState({ motherParameterModalVisible: true })}>
	                                                                + MOTHER PARAMETER
	                                                            </a>
	                                                        :
	                                                        null
	                                                    }
	                                                </div>
	                                            </div>
	                                            {
	                                            	this.state.currentPregnancyData?.mother_parameter_data ?
	                                                <>
	                                                    <div className='row mt-3 '>
	                                                        <table className="table table-bordered mt-3" >
	                                                            <thead>
	                                                                <tr>
	                                                                    <td width="15%">DATE &amp; TIME</td>
	                                                                    <td width="11%">SAVED BY</td>
	                                                                    <td width="9%">POG (WEEKS)</td>
	                                                                    <td width="5%">WEIGHT (KG)</td>
	                                                                    <td width="9%">BP (MMHG)</td>
	                                                                    <td width="9%">PULSE RATE (MIN)</td>
	                                                                    <td width="9%">FUNDAL HT (CM)</td>
	                                                                    <td width="8%">EDEMA</td>
	                                                                    <td width="8%">PALLOR</td>
	                                                                    <td width="8%">CERVIX EXAM</td>
	                                                                    <td width="9%">PRETERM LABOUR (SIGN/SYMPTOMS)</td>
	                                                                </tr>
	                                                            </thead>
	                                                            <tbody>
	                                                            	{this.showMotherParametersRows()}
	                                                            </tbody>
	                                                        </table>
	                                                    </div>
	                                                </>
	                                                : 
	                                                <div className='row'>
	                                                    <table className="table table-bordered mt-3">
	                                                        <tbody>
	                                                            <tr><td className="text-center">No data available</td></tr>
	                                                        </tbody>
	                                                    </table>
	                                                </div>
	                                            }
	                                            <div className='row mt-3 align-items-center'>
	                                                <div className='col-4 d-flex align-items-center'>
	                                                    <span className='title'>Fetal Parameters</span>
	                                                </div>
	                                                <div className='col-4 text-center'>
	                                                    {
	                                                        this.state.previousMotherFetusData.length > 0
	                                                        ?
	                                                            <a href='javascript:void(0)' className='text-primary' onClick={this.openPreviousMotherFetusHistory}>
	                                                                Previous Mother Fetus Details
	                                                            </a>
	                                                        :
	                                                        null
	                                                    }
	                                                </div>
	                                                <div className='col-4 text-right'>
	                                                    {
	                                                        this.state.allowEdit && this.hasNoOfFetus()
	                                                        ?
	                                                            <a className='btn btn-outline-primary small px-2' onClick={() => this.setState({ fetusModalVisible: true })}>
	                                                                + FETAL PARAMETER
	                                                            </a>
	                                                        :
	                                                        null
	                                                    }
	                                                </div>
	                                            </div>
	                                            {this.showFetalParameterTables()}
	                                        </>
                                        : 
                                        null
                                    }
                                    <VaccineOptional
                                        vaccineData={this.state.vaccineData}
                                        vaccineItemList={this.state.vaccineItemList}
                                        vaccinationSites={this.state.vaccinationSites}
                                        patientDob={this.state.patientInfo?.dob || null}
                                        allowEdit={this.state.allowEdit}
                                        onVaccineDate={this.handleVaccineDate}
                                        onGivenOutside={this.handleVaccineGivenOutside}
                                        onFieldChange={this.handleVaccineFieldChange}
                                        onSelectChange={this.handleVaccineSelectChange}
                                        onExpiryDate={this.handleVaccineExpiryDate}
                                        onAddDose={this.handleVaccineAddDose}
                                        disabledPastDate={this.disabledPastDate}
                                    />

                                    {/* Investigations (Test & Procedure Results + Title/Description rows) - separate component keyed by anc_id */}
                                    <AncTestProcedures
                                        anc_id={this.state.anc_id}
                                        patient_id={parseInt(LS_SERVICE.get('PATIENT_REG_DATA')?.registrationid)}
                                        facility_id={parseInt(LS_SERVICE.get('FACILITY_ID'))}
                                        enterprise_id={parseInt(LS_SERVICE.get('ENTERPRISE_ID'))}
                                        encounter_id={parseInt(LS_SERVICE.get('PATIENT_ENCOUNTER_ID') || 0)}
                                        allowEdit={this.state.allowEdit}
                                        testProcedureRows={this.state.test_procedures_data}
                                        onTestProcedureRowsChange={(rows) => this.setState({ test_procedures_data: rows })}
                                    />

                                	<div className='row d-flex align-items-start mt-4 mb-4'>
                                        <div className='col-6'>
                                            <div className="antSelectItem hasdata mb-0">
                                                <Form.Item
                                                    label="Pregnancy risk factors"
                                                    name="pregnancy_risk_factor"
                                                    className='mb-0'
                                                >
                                                    <Select
                                                        showSearch
                                                        mode="multiple"
                                                        value={this.state.pregnancy_risk_factor_selected}
                                                        notFoundContent={null}
                                                        filterOption={true}
                                                        disabled={!this.state.allowEdit}
                                                        onChange={this.handleOnPregnancyRiskFactorChange}
                                                        style={{ width: '100%', minHeight: '40px' }}
                                                        optionFilterProp="children"
                                                    >
                                                        {this.optionRiskFactorsLoad()}
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='col-6'>
                                            <div className={`form-group antInputItem micwrap hasdata mb-0`}>
                                                <Link
                                                    onClick={(e) => {
                                                        e.preventDefault(); this.initSpeech({ identifier: "pregnancy_risk_factor_management_remarks" });
                                                    }}
                                                    className={
                                                        this.state.speech.identifier === "pregnancy_risk_factor_management_remarks" && this.state.speech.state ? "mic subjective-mic on mute" : "mic subjective-mic"
                                                    }
                                                ></Link>
                                                <Form.Item
                                                    name="pregnancy_risk_factor_management_remarks"
                                                    className='mb-0'
                                                >
                                                    <Input.TextArea
                                                        className="form-control diagnosis_notes_class speech-field"
                                                        id="pregnancy_risk_factor_management_remarks"
                                                        name="pregnancy_risk_factor_management_remarks"
                                                        autoSize={{ minRows: 1.3, maxRows: 6 }}
                                                        maxLength={255}
                                                        disabled={!this.state.allowEdit}
                                                        style={{ minHeight: '40px' }}
                                                        onInput={(e) => this.autoHeight(e)}
                                                        onChange={this.handleOnTextChange}
                                                        value={this.state.pregnancy_risk_factor_management_remarks}
                                                    />
                                                </Form.Item>
                                                <label htmlFor="pregnancy_risk_factor_management_remarks">Pregnancy Risk Factor Management Remarks</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row mt-3 mb-5'>
                                        <div className='col-12 text-center'>
                                            <Form.Item>
                                                <button onClick={() => this.printAncDetails()} type="button" className="btn btn-primary px-5 mr-3">Print {this.state.isPrintLoader ? LOADER : null}</button>
                                                <button htmlType="submit" className="btn btn-primary px-5 ml-3" disabled={this.state.spin_loading}>SAVE {this.state.spin_loading ? LOADER : null}</button>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </Form>
                            </>
                            :
                            null
                        }

                        {
                        	/* Previous (closed) ANC cards below the active one, in collapsed state */
                        	prevAncCardData.length > 0  
                        	?
                            	prevAncCardData.map((obj, index) => {
	                                return (
	                                    <AncCardView
                                            ref={this.createRef}
                                            patientInfo={patientInfo}
                                            AncCardData={obj}
                                            index={index}
                                            riskFactorsOptions={this.state.risk_factors_options}
                                        />
	                                );
                            	})
                            : 
                            null
                        }
                    </div>
                </div >

                {/* Close Pregnancy -> Delivery Details modal */}
                {
                    this.state.deliveryDetailsModalVisible
                    ?
                        <DeliveryDetailsModal
                            visible={this.state.deliveryDetailsModalVisible}
                            allowEdit={this.state.allowEdit}
                            onClose={() => this.setState({ deliveryDetailsModalVisible: false })}
                            /* Closing the pregnancy (saving delivery details) also moves the
                               current pregnancy into the patient's history, so refresh the
                               "Previous ANC" data and mother/fetus history too — not just the
                               current ANC/obs-gynae/patient data — so the page reflects it
                               without a manual reload. */
                            onSaved={() => { this.getPatientAncDetails(); this.getPatientObsGyaneData(); this.getPatientData(); this.getPatientAncPreviousDetails(); this.getPreviousMotherHistory(); }}
                        />
                    :
                    null
                }

                {/* + Mother Parameter -> add a new mother-parameter record for this visit */}
                {
                    this.state.motherParameterModalVisible
                    ?
                        <MotherParameterModal
                            visible={this.state.motherParameterModalVisible}
                            allowEdit={this.state.allowEdit}
                            lmp={this.state.currentPregnancyData?.menstural_data?.lmp || null}
                            onClose={() => this.setState({ motherParameterModalVisible: false })}
                            onSaved={() => { this.getPatientObsGyaneData(); this.getPreviousMotherHistory(); }}
                        />
                    :
                    null
                }

                {/* + Fetus -> add/update a fetus record (by fetus_no) for this visit */}
                {
                    this.state.fetusModalVisible
                    ?
                        <FetusModal
                            visible={this.state.fetusModalVisible}
                            allowEdit={this.state.allowEdit}
                            noOfFetus={this.state.currentPregnancyData?.no_of_fetus || null}
                            existingFetusData={this.state.currentPregnancyData?.mother_fetus_data || []}
                            onClose={() => this.setState({ fetusModalVisible: false })}
                            onSaved={() => { this.getPatientObsGyaneData(); this.getPreviousMotherHistory(); }}
                        />
                    :
                    null
                }

                {/* Patient-level read-only mother and fetus histories, across all references */}
                {
                    this.state.previousMotherParameterModalVisible
                    ?
                        <PreviousMotherHistoryModal
                            visible={this.state.previousMotherParameterModalVisible}
                            type="mother"
                            motherParameters={this.state.previousMotherParameters}
                            motherFetusData={this.state.previousMotherFetusData}
                            onClose={() => this.setState({ previousMotherParameterModalVisible: false })}
                        />
                    : null
                }
                {
                    this.state.previousMotherFetusModalVisible
                    ?
                        <PreviousMotherHistoryModal
                            visible={this.state.previousMotherFetusModalVisible}
                            type="fetus"
                            motherParameters={this.state.previousMotherParameters}
                            motherFetusData={this.state.previousMotherFetusData}
                            onClose={() => this.setState({ previousMotherFetusModalVisible: false })}
                        />
                    : null
                }

                {/* Modal For Multiple Pregnancies */}
                <Modal
                    title="Multiple Pregnancy Details"
                    destroyOnClose={true}
                    visible={this.state.multiplePregnanciesModal}
                    onCancel={(e) =>
                        this.handleModalPopup(e, "multiplePregnanciesModal")
                    }
                    width="1800px"
                    bodyStyle={{ paddingBottom: "15px" }}
                    className="emrfrm"
                    footer={false}
                >
                    {this.state.multiplePregnanciesModal ?
                        <MultiplePregnancies
                            allowEdit={this.state.allowEdit}
                            multiple_pregnancies={this.state.multiple_pregnancies}
                            handleModalSave={this.handleModalSave}
                        />
                        : null}
                </Modal>

                <Modal
                    title="Anc Details"
                    visible={this.state.showRxModal}
                    footer={false}
                    width={850}
                    onCancel={() => { this.setState({ showRxModal: false, rxPdfPath: null }) }}
                    style={{ top: 20 }}
                >
                    <div className="row">
                        <div className="col-12 my-3 text-center">
                            <iframe src={this.state.rxPdfPath} frameBorder="0" scrolling="no" style={{ overflow: 'hidden' }} width="100%" height="700"></iframe>
                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}
